<template>
  <div class="dropdown">
    <button
        class="btn btn-primary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        @click="toggleDropdown"
        :aria-expanded="isOpen.toString()">
      Aktion
    </button>
    <ul v-show="isOpen"
        class="dropdown-menu "
        style="right: 0; left: unset;"
        :aria-labelledby="'dropdownMenuButton'">

      <!--- ADMIN --->
      <template v-if="userRole === 'ROLE_ADMIN'">
        <template v-if="report.status !== 'approved'">
          <!-- Approve as admin -->
          <a class="dropdown-item" @click="approveRequest(report.id, 'admin')">
            {{ approveAsAdminLabel }}
          </a>

          <!-- Approve as coordinator -->
          <a class="dropdown-item" @click="approveRequest(report.id, 'coordinator')">
            {{ approveAsCoordinatorLabel }}
          </a>
        </template>

        <!-- Not declined -->
        <a v-if="report.status === 'pending'"  @click="declineRequest(report.id)"
           class="dropdown-item">
          Ablehnen
        </a>
      </template>


      <!--- COORDINATOR(SITE MANAGER) --->
      <template
          v-if="
          userRole === 'ROLE_SITE_MANAGER' ||
          userRole === 'ROLE_HEAD_OF_AMDL' ||
          userRole === 'ROLE_HEAD_OF_MARKETING' ||
          userRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
          userRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES'">

        <div v-if="report.coordinatorApprove == null">
          <a class="dropdown-item" @click="approveRequest(holiday.id, 'coordinator')">
            {{ approveAsCoordinatorLabel }}
          </a>

          <a v-if="report.status === 'pending'"
             class="dropdown-item">
            Ablehnen
          </a>
        </div>
      </template>
    </ul>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  userRole: {
    type: String,
    required: true,
  },
  report: {
    type: Object,
    required: true,
  },
  approveAsAdminLabel: {
    type: String,
    required: true,
  },
  approveAsCoordinatorLabel: {
    type: String,
    required: true,
  },
  approveLabel: {
    type: String,
    required: true,
  },
});

const emit = defineEmits([ 'toggle', 'approveRequest', 'declineRequest' ]);

const toggleDropdown = () => {
  emit('toggle');
};

function approveRequest(requestId, approveBy) {
  emit('approveRequest', requestId, approveBy);
}

function declineRequest(requestId) {
  emit('declineRequest', requestId);
}

</script>

<style scoped>
.dropdown {
  width: 100%; /* Ensure the dropdown takes up available space */
}

.dropdown-menu {
  font-size: 14px;
  max-width: 250px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute; /* Ensures it's positioned relative to the parent */
  z-index: 5000; /* Make sure it appears above other elements */
}

.dropdown-menu[style] {
  display: block;
}

.dropdown-item {
  word-wrap: break-word; /* Ensure long words break if needed */
}
</style>
